/** The most numbers a game may report about itself, so its samples stay within the event limits. */
export const MAX_GAME_NUMBERS = 6;
const NAME = /^[a-z][a-z0-9_]{0,23}$/;

/**
 * A game's own numbers (`GameClient.diagnostics()`, P3-OBS-04) as the host records them: prefixed
 * `game_`, finite numbers only, the first six with good names. A game that throws reports nothing.
 */
export function gameNumbers(
  read: (() => Readonly<Record<string, number>>) | undefined,
): Record<string, number> {
  if (!read) return {};
  let raw: Readonly<Record<string, unknown>>;
  try {
    raw = read();
  } catch {
    return {};
  }
  const out: Record<string, number> = {};
  let n = 0;
  for (const [name, value] of Object.entries(raw)) {
    if (n >= MAX_GAME_NUMBERS) break;
    if (!NAME.test(name) || typeof value !== "number" || !Number.isFinite(value)) continue;
    out[`game_${name}`] = value;
    n++;
  }
  return out;
}
